import React, { useState } from "react";
import { Lightbulb, Send, CheckCircle2, MessageSquareDashed } from "lucide-react";
import { useAuth } from "../../auth/AuthContext";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function FeedbackPanel() {
  const { authFetch } = useAuth();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    setLoading(true);
    setError("");
    try {
      const res = await authFetch(`${API_BASE}/feedback`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message }),
      });
      
      if (res.ok) {
        setSubmitted(true);
        setMessage("");
      } else {
        const data = await res.json();
        setError(data.error || "เกิดข้อผิดพลาด");
      }
    } catch (err) {
      setError("ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-5 text-sm pb-10">
      <h2 className="flex items-center gap-2 font-bold text-lg text-slate-800 tracking-tight">
        <Lightbulb className="text-amber-500" size={20} />
        ข้อเสนอแนะ & แจ้งปัญหา
      </h2>

      {submitted ? (
        <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-8 text-center animate-fadeIn shadow-sm">
          <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm shadow-emerald-200">
            <CheckCircle2 size={32} />
          </div>
          <h3 className="text-lg font-bold text-emerald-800 mb-2">ขอบคุณสำหรับข้อเสนอแนะ!</h3>
          <p className="text-emerald-600 font-medium">เราจะนำข้อมูลของคุณไปพัฒนาและปรับปรุงระบบให้ดียิ่งขึ้น</p>
          <button
            onClick={() => setSubmitted(false)}
            className="mt-6 px-6 py-2.5 bg-emerald-600 text-white rounded-xl font-medium hover:bg-emerald-700 hover:shadow-md hover:shadow-emerald-500/20 active:scale-95 transition-all duration-200"
          >
            ส่งข้อเสนอแนะเพิ่มเติม
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="bg-white/80 backdrop-blur-md border border-slate-200/80 rounded-2xl p-5 shadow-sm">
          <div className="flex items-start gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center flex-shrink-0">
              <MessageSquareDashed size={20} className="text-amber-600" />
            </div>
            <p className="text-slate-600 leading-relaxed text-[13px]">
              หากคุณมีข้อเสนอแนะ ต้องการฟีเจอร์ใหม่ หรือพบปัญหาในการใช้งาน สามารถแจ้งให้ทีมพัฒนาทราบได้ที่นี่ ทุกความคิดเห็นของคุณมีความสำคัญต่อการพัฒนาระบบ
            </p>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 text-red-600 border border-red-200 rounded-xl text-xs font-medium">
              {error}
            </div>
          )}

          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="พิมพ์ข้อเสนอแนะ ฟีเจอร์ที่อยากได้ หรือปัญหาที่พบ..."
            className="w-full h-36 p-4 bg-slate-50 border border-slate-200/80 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-amber-500/30 focus:border-amber-400 focus:bg-white transition-all text-sm text-slate-700 shadow-inner shadow-slate-100"
            required
          />

          <div className="mt-4 flex justify-end">
            <button
              type="submit"
              disabled={loading || !message.trim()}
              className="flex items-center gap-2 px-6 py-2.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-xl font-medium shadow-md shadow-amber-500/20 hover:shadow-lg hover:shadow-amber-500/30 disabled:opacity-50 disabled:cursor-not-allowed hover:-translate-y-0.5 active:scale-95 transition-all duration-200"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                <>
                  <Send size={16} />
                  ส่งข้อเสนอแนะ
                </>
              )}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
